import styled from "styled-components";

export const Container = styled.div`
  background: #010313;
  min-height: 100vh;
`
